import axios from 'axios';


const url = process.env.REACT_APP_BASE_API_URL;

export const findEntradasXSaidas = async(dataInicial, dataFinal) => {
    const headers = { 'Content-Type': 'application/json'}
    return await axios.get(url + '/v1/kpi/entradasxsaidas/' + dataInicial + '/' + dataFinal, {headers});
}

export const findTempoMedioAnalise = async(usuid, dataInicial, dataFinal) => {
    const headers = { 'Content-Type': 'application/json'}
    return await axios.get(url + '/v1/kpi/tempomedioanalise/' + usuid + '/' + dataInicial + '/' + dataFinal, {headers});
}
export const findTempoMedioVeredito = async(usuid, dataInicial, dataFinal) => {
    const headers = { 'Content-Type': 'application/json'}
    return await axios.get(url + '/v1/kpi/tempomedioveredito/' + usuid + '/' + dataInicial + '/' + dataFinal, {headers});
}
export const findDivergenciaVeredito = async(usuid, dataInicial, dataFinal) => {
    const headers = { 'Content-Type': 'application/json'}
    return await axios.get(url + '/v1/kpi/divergenciaveredito/' + usuid + '/' + dataInicial + '/' + dataFinal, {headers});
}
export const findDivergenciaIa = async(usuid, dataInicial, dataFinal) => {
    const headers = { 'Content-Type': 'application/json'}
    return await axios.get(url + '/v1/kpi/divergenciaia/' + usuid + '/' + dataInicial + '/' + dataFinal, {headers});
}
export const findProdutividade = async(usuid, dataInicial, dataFinal) => {
    const headers = { 'Content-Type': 'application/json'}
    return await axios.get(url + '/v1/kpi/produtividade/' + usuid + '/' + dataInicial + '/' + dataFinal, {headers});
}
export const findOperadores = async(usuid, dataInicial, dataFinal) => {
    const headers = { 'Content-Type': 'application/json'}
    return await axios.get(url + '/v1/kpi/operadores/' + usuid + '/' + dataInicial + '/' + dataFinal, {headers});
}
